import { NavMain } from "./nav-main";
import { NavUser } from "./nav-user";
import { AppSwitcher } from "./app-switcher";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarSeparator,
  useSidebar,
} from "@/components/ui/sidebar";
import LogoMD from "@/assets/logo-md.svg";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { EntitySwitcher } from "./entity-switcher";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <Sidebar collapsible="icon" {...props}>
      <Link to="/" className="focus:ring-0 outline-none">
        <SidebarGroup
          className={cn(
            "flex flex-row justify-start items-center gap-1 p-3 pt-4"
          )}
        >
          <div className={isCollapsed ? "flex items-center w-full " : ""}>
            <LogoMD />
          </div>
          {!isCollapsed && (
            <SidebarGroupLabel
              className="w-[50%] text-slate-500/90"
              style={{
                lineHeight: "16.94px",
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              Performance Auto Group
            </SidebarGroupLabel>
          )}
        </SidebarGroup>
      </Link>
      <SidebarSeparator />
      <SidebarGroup>
        <AppSwitcher />
      </SidebarGroup>
      <SidebarGroup>
        <EntitySwitcher />
      </SidebarGroup>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      {/* <SidebarRail /> */}
    </Sidebar>
  );
}
